import { render, staticRenderFns } from "./PartPage.vue?vue&type=template&id=52bc54d4&"
import script from "./PartPage.vue?vue&type=script&lang=js&"
export * from "./PartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports